import * as React from "react"
import { Button, Col, Container, Row } from "react-bootstrap"
import FAQItem from "./FAQItem"
import * as styles from "./styles.module.scss"

type Items = {
  "@type": string
  name: string
  acceptedAnswer: {
    "@type": string
    text: string
  }
}

type TFAQ = {
  title?: string
  before?: string
  items: Items[]
  button?: { href: string; text: string }
  isTitle?: boolean
  className?: string
}

export default function FAQ({ title = "Часто задаваемые вопросы", before, items, button, isTitle, className }: TFAQ) {
  return (
    <Container className={styles.faqSection}>
      {!isTitle && (
        <Row>
          <Col cols={12} lg={10} xl={9}>
            <h2 className="h1 mb-4 w-100" style={{ maxWidth: "100%", padding: 0 }}>
              {title}
            </h2>
          </Col>
        </Row>
      )}

      {before && (
        <Row>
          <Col className={className} cols={12} lg={10} xl={9}>
            <div
              dangerouslySetInnerHTML={{
                __html: before,
              }}
            />
          </Col>
        </Row>
      )}

      {items && (
        <Row>
          <Col className={className} itemScope itemType="http://schema.org/FAQPage">
            {items.map((item, index) => (
              <FAQItem item={item} key={index} />
            ))}
          </Col>
        </Row>
      )}

      {button && (
        <Row>
          <Col>
            <Button href={button.href} variant="primary" className="py-3 px-4 px-md-5 mt-4 mt-md-5">
              {button.text}
            </Button>
          </Col>
        </Row>
      )}
    </Container>
  )
}
